import React from "react";
import { motion } from "framer-motion";
import styles from "./index.module.css";
import phoneImage from "../../assets/touch-pos-closeup.png";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.75, ease: "easeOut" },
  },
};

const fadeInRight = {
  hidden: { opacity: 0, x: 60 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.9, ease: "easeOut", delay: 0.15 },
  },
};

const UpgradeYourBusinessSection = () => {
  return (
    <div className={styles.mainDiv}>
      <div className={styles.banner}>
        <div className={styles.info}>
          <div className={styles.top}>
            <motion.div
              className={styles.title}
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
            >
              Upgrade Your Business with Our Cutting Edge POS Solutions
            </motion.div>
            <motion.div
              className={styles.mobImgDiv}
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
            >
              <img
                className={styles.mobImg}
                src={phoneImage}
                alt="banner-phone"
                loading="lazy"
              />
            </motion.div>
            <motion.div
              className={styles.description}
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.75, ease: "easeOut", delay: 0.1 }}
            >
              Experience the future of transactions! Schedule a demo today and
              witness how our POS solution can revolutionize your business.
            </motion.div>
          </div>
          <motion.div
            className={styles.bottom}
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.75, ease: "easeOut", delay: 0.2 }}
          >
            <div className={styles.btnDiv}>
              <a
                className={styles.links}
                href="https://onboard.epinics.com/"
                target="_blank"
                rel="noreferrer"
              >
                <div className={styles.trialBtn}>Start Free Trial</div>
              </a>
              <a
                className={styles.links}
                href="https://onboard.epinics.com/"
                target="_blank"
                rel="noreferrer"
              >
                <div className={styles.purchaseBtn}>Purchase Now</div>
              </a>
            </div>
          </motion.div>
        </div>
        <motion.img
          className={styles.img}
          src={phoneImage}
          alt="banner-phone"
          loading="lazy"
          variants={fadeInRight}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        />
      </div>
    </div>
  );
};

export default UpgradeYourBusinessSection;
